package dev.lingvo.site.components.studio.preview

import dev.lingvo.shared.screenshots.doc.GroupLayer
import dev.lingvo.shared.screenshots.doc.DeviceLayer
import dev.lingvo.shared.screenshots.doc.ImageLayer
import dev.lingvo.shared.screenshots.doc.ImageSource
import dev.lingvo.shared.screenshots.doc.Layer

/** Shares artwork discovery between authenticated preloading and pure resource-boundary tests. */
internal fun previewAssetIds(layers: List<Layer>, logoAssetId: String?): List<String> {
    fun assets(layer: Layer): List<String> = when (layer) {
        is DeviceLayer -> listOfNotNull((layer.screen as? ImageSource.Asset)?.assetId)
        is ImageLayer -> listOfNotNull((layer.source as? ImageSource.Asset)?.assetId)
        is GroupLayer -> layer.children.flatMap(::assets)
        else -> emptyList()
    }
    return (layers.flatMap(::assets) + listOfNotNull(logoAssetId)).distinct()
}
